import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useCompany } from "../../../Shared/components/CompanyProvider/CompanyProvider";
import { useOrderFlow } from "../../OrderFlowProvider/OrderFlowContext";
import { usePaymentForm } from "../../../Shared/components/PaymentForm/usePaymentForm";
const getNextButtonText = (isSubscriptionSummary, isLastPage) => {
    if (isSubscriptionSummary)
        return "Save";
    else if (isLastPage)
        return "View Changes";
    else
        return "Continue";
};
export const useNavigationButtons = (selectedOrders) => {
    var _a, _b, _c, _d, _e;
    const { store } = useOrderFlow();
    const { openedFromMobileApp } = useCompany();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
    const { balance, paymentMethod, giftCard } = usePaymentForm();
    const [isConfirmChangesChecked, setIsConfirmChangesChecked] = useState(false);
    const [numberOfSelectedOrders, setNumberOfSelectedOrders] = useState((_a = selectedOrders === null || selectedOrders === void 0 ? void 0 : selectedOrders.length) !== null && _a !== void 0 ? _a : 0);
    const isLastPage = store.cart.currentPage === store.cart.totalPages;
    const emptyOrder = !store ||
        ((!store.cart.meals || !store.cart.meals.length) &&
            (!store.cart.products || !store.cart.products.filter((p) => p.quantity > 0).length) &&
            store.model.IsEditFlow &&
            (!store.cart.template || !store.cart.template.filter((t) => t.Quantity > 0).length));
    const containerStyleProps = {
        pinNavButtons: (_d = (_c = (_b = store === null || store === void 0 ? void 0 : store.model) === null || _b === void 0 ? void 0 : _b.OrderFlowSettings) === null || _c === void 0 ? void 0 : _c.PinNavButtons) !== null && _d !== void 0 ? _d : false,
        isMobile,
        openedFromMobileApp,
    };
    const hidePreviousButton = store.cart.currentPage === 1 && store.model.IsEditFlow;
    const nextButtonText = getNextButtonText(store.model.IsEditFlow, isLastPage);
    const giftCardCoversBalance = !!(giftCard === null || giftCard === void 0 ? void 0 : giftCard.balance) && giftCard.balance > ((_e = balance === null || balance === void 0 ? void 0 : balance.remainingBalance) !== null && _e !== void 0 ? _e : 0);
    const canBalanceBePaid = !!paymentMethod || giftCardCoversBalance;
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            setNumberOfSelectedOrders((prev) => {
                if (selectedOrders && (selectedOrders === null || selectedOrders === void 0 ? void 0 : selectedOrders.length) !== prev) {
                    setIsConfirmChangesChecked(false);
                    return selectedOrders.length;
                }
                return prev;
            });
        }
        return () => {
            mounted = false;
        };
    }, [selectedOrders]);
    return {
        containerStyleProps,
        currentPage: store.cart.currentPage,
        emptyOrder,
        hidePreviousButton,
        isEditFlow: store.model.IsEditFlow,
        isLastPage,
        isMobile,
        nextButtonText,
        isConfirmChangesChecked,
        setIsConfirmChangesChecked,
        disablePaymentButton: Boolean(balance && !canBalanceBePaid),
        confirmChangesLabel: store.model.UpdateOrdersConfirmationText
    };
};
